import React from "react";
import ContestedClaimsV2Wrapper from "@/components/route-wrappers/contested-claims-v2";
import { useRouter } from "next/router";
import DefaultHead from "@/components/default/head";
import DefaultRouter from "@/components/routers/default";
import { ServiceWrapper } from "@/context/ServiceContext";
import RouterV2 from "@/components/routers/v2";

const Router = ({ Component, pageProps, ...rest }) => {
    const router = useRouter();
    const notFound =
        router.asPath.includes("/404") || router.pathname.includes("/404") ||
        (router.pathname.length === 1 && router.asPath.length > 1);

    // if (/^\/demo/.test(router?.asPath ?? "") && !notFound) {
    //     return <ContestedClaimsV2Wrapper {...props}/>;
    // }
    //
    // if (/^\/bestridte-krav/.test(router?.asPath ?? "") && !notFound) {
    //     return <ContestedClaimsV1Wrapper {...props}/>;
    // }

    if (/^\/bestridte-krav/.test(router?.asPath ?? "") && !notFound) {
        return <ContestedClaimsV2Wrapper Component={Component} pageProps={pageProps} {...rest}/>;
    }

    if (/^\/finn/.test(router?.asPath ?? "") && !notFound) {
        return <RouterV2 Component={Component} pageProps={pageProps} {...rest} storageKey="finn"/>;
    }

    if (/^\/samlivsbrudd/.test(router?.asPath ?? "") && !notFound) {
        return <RouterV2 Component={Component} pageProps={pageProps} {...rest} storageKey="divorce"/>;
    }

    if (router.pathname === "/tryg-boligkjop" && !notFound) {
        return (
            <>
                <DefaultHead title="Overfør sak til Mekle | Tryg Boligkjøperforsikring"/>
                <Component {...pageProps}/>
            </>
        );
    }

    return (
        <ServiceWrapper>
            <DefaultRouter Component={Component} pageProps={pageProps} {...rest}/>
        </ServiceWrapper>
    );
};

export default Router;
